import React from 'react';
import FormBase from 'components/FormBase';
import './RegisterForm.css';

export default function RegisterForm(prop) {
    const register_scene_path = process.env.PUBLIC_URL + '/img/register_scene.png';
    const register_human1_path = process.env.PUBLIC_URL + '/img/register_scene_human1.png';
    const register_human2_path = process.env.PUBLIC_URL + '/img/register_scene_human2.png';

    return (
        <FormBase title={prop.title} >
            <div className={'registerFormScene'}>
                <img src={register_scene_path} alt={'login scene'} width={'100%'} height={'100%'} />
            </div>
            <div className={'registerFormScene_human1'}>
                <img src={register_human1_path} alt={'login scene'} width={'100%'} height={'100%'} />
            </div>
            <div className={'registerFormScene_human2'}>
                <img src={register_human2_path} alt={'login scene'} width={'100%'} height={'100%'} />
            </div>
            <div className={'registerFormContent'} >
                {prop.children}
            </div>
        </FormBase>
    )
}